<template>
  <v-container class="pa-0">
    <h1>{{ $t('texts.resetPassword') }}</h1>
    <v-card>
      <v-card-text>
        <v-container class="pa-0" grid-list-md>
          <v-row>
            <v-col>
              <v-text-field
                data-vv-name="email"
                :label="$t('texts.email')"
                value=""
                v-model="encodedEmail"
                required
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                disabled
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="12" :sm="6">
              <v-text-field
                type="password"
                :label="$t('texts.password')"
                v-model="password"
                required
                v-validate="'required|min:8|verify_password'"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                :data-vv-as="$t('texts.password')"
                ref="password"
              />
            </v-col>
            <v-col :cols="12" :sm="6">
              <v-text-field
                type="password"
                :label="$t('texts.password')"
                v-model="password_confirmation"
                required
                hide-details
                v-validate="'required|confirmed:password'"
                :error-messages="errors.collect('password_confirmation')"
                data-vv-name="password_confirmation"
                :data-vv-as="$t('texts.password')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
          <v-btn
            color="primary"
            @click="validateBeforeSubmit()"
            :disabled="sendPasswordResetPending"
            :loading="sendPasswordResetPending"
          >
            {{ $t('texts.resetPassword') }}
            <v-icon right class="white--text">check_circle</v-icon>
          </v-btn>
      </v-card-actions>
    </v-card>

  </v-container>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapUserState, mapActions: mapUserActions } = createNamespacedHelpers('user');
const { mapActions: mapMessageActions } = createNamespacedHelpers('messages');

export default {
  name: 'PasswordReset',
  props: {
    token: {
      type: String,
    },
    email: {
      type: String,
    },
  },
  data() {
    return {
      encodedEmail: '',
      password: '',
      password_confirmation: '',
    };
  },
  $_veeValidate: {
    validator: 'new',
  },
  created() {
    this.encodedEmail = atob(this.email);
  },
  computed: {
    ...mapUserState([
      'sendPasswordResetPending',
    ]),
  },
  methods: {
    ...mapUserActions([
      'sendPasswordReset',
    ]),
    ...mapMessageActions([
      'showMessageValidateError',
    ]),
    showUserLoginDialog() {
      this.$eventBus.$emit('show-user-login-dialog');
    },
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const form = {
            token: this.token,
            email: this.encodedEmail,
            password: this.password,
            password_confirmation: this.password_confirmation,
          };
          this.sendPasswordReset(form).then((response) => {
            if (response.status === 200) {
              this.$router.push({ path: '/' });
              this.showUserLoginDialog();
            }
          });
        } else {
          this.showMessageValidateError();
        }
      });
    },
  },
};
</script>
